import { useEffect, useState } from 'react';
import '@/App.css';
import StartScreen from './screens/StartScreen';
import WorldSelect from './screens/WorldSelect';
import SettingsScreen from './screens/SettingsScreen';
import GameScreen from './screens/GameScreen';

function App() {
  // routes: start | worlds | settings | game
  const [route, setRoute] = useState('start');
  const [settingsReturn, setSettingsReturn] = useState('start');

  useEffect(() => {
    // Prevent scroll on mobile during game
    document.body.style.overflow = route === 'game' ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [route]);

  return (
    <div className="neon-app">
      {route === 'start' && (
        <StartScreen
          onPlay={() => setRoute('worlds')}
          onContinue={() => setRoute('game')}
          onSettings={() => { setSettingsReturn('start'); setRoute('settings'); }}
        />
      )}
      {route === 'worlds' && (
        <WorldSelect
          onBack={() => setRoute('start')}
          onSelectWorld={() => setRoute('game')}
        />
      )}
      {route === 'settings' && (
        <SettingsScreen onBack={() => setRoute(settingsReturn)} />
      )}
      {route === 'game' && (
        <GameScreen onExit={() => setRoute('start')} />
      )}
    </div>
  );
}

export default App;
